import { render, staticRenderFns } from "./CPanels.vue?vue&type=template&id=2064fb79&scoped=true&"
import script from "./CPanels.vue?vue&type=script&lang=js&"
export * from "./CPanels.vue?vue&type=script&lang=js&"
import style0 from "./CPanels.vue?vue&type=style&index=0&id=2064fb79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2064fb79",
  null
  
)

export default component.exports